/* eslint new-cap: ["error", { "newIsCapExceptionPattern": "^viewModel\.", "capIsNewExceptions": ["$.Deferred"] }] */
define('v3/Common/Services/Frontend/Modal.Service',[
	'jquery',
	'knockout',
	'lodash',
	'module',
	'require',
	'env',
	'v3/Common/Services/Frontend/Mask.Service',
	'jquery.modal',
	'jquery.fullscreen',
	'v3/FromV2/utils'
], function ($, ko, _, module, require, env, mask) {
	var defaults = {
		// Custom variables
		closable: true,
		title: '',
		content: false,
		buttons: [],
		iconHtml: '<svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + env.paths.svgSprite + '#{ICON}"></use></svg>',
		icon: '',
		loader: false,
		fullscreen: false,
		openFullscreen: false,
		showFullscreen: false,
		backgroundClass: '',
		badge: '',

		// Library defaults
		closeExisting: false,
		escapeClose: true,
		clickClose: true,
		closeText: '<svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + env.paths.svgSprite + '#Close"></use></svg>',
		closeClass: '',
		modalClass: 'modal',
		spinnerHtml: null,
		showSpinner: true,
		showClose: true,
		fadeDuration: null,
		fadeDelay: 1.0
	};

	function ModalHelper (options) {
		if (typeof options !== 'object' || !options) throw new Error('Please provide an \'options\' parameter.');

		var self = this;
		var viewModel = options.viewModel || {};
		var template = options.template || viewModel.template;
		var context = options.context;
		var settings = options.settings || viewModel.settings || options;
		var requireViewModel = options.require;
		var params = options.params;
		var defferedModalResult = $.Deferred();

		this.settings = $.extend({}, defaults, settings);
		this.$modal = $('<div class="inner"></div>');
		this.modalId = _.uniqueId('modal');
		this.closedByViewModel = false;
		this.doNotPreventClosing = false;

		if (this.settings.closable === false) {
			this.settings.showClose = false;
			this.settings.escapeClose = false;
			this.settings.clickClose = false;
		}

		if (template instanceof $) {
			self.$ui = template;
			self.events.onOpen.call(self, defferedModalResult, context);
			self.viewModel.addLoader.call(self, viewModel);
			self.show({});
			self.events.onPromiseComplete.call(self, defferedModalResult, viewModel);
			self.events.onClose.call(self, false, defferedModalResult, viewModel);
			self.viewModel.addFullscreen.call(self, {});

			return defferedModalResult;
		} else {
			if (!requireViewModel) {
				if (!template) { throw new Error('options.template or viewModel.template is required.'); }

				if (typeof options.viewModel === 'undefined') { throw new Error('options.viewModel is required.'); }

				if (!_.isObjectLike(viewModel) || _.isArray(viewModel)) { throw new Error('viewModel requires either a object or a constructor.'); }
			} else {
				// self.viewModel.checkFullscreen.call(self);

				var promise = $.Deferred();
				require([requireViewModel], function (viewModel) {
					var templateId = _.uniqueId('template');
					var tmp = $('<script type="text/html"></script>').attr('id', templateId);
					tmp[0].innerHTML = '<div class="modal-content">' + viewModel.template + '</div>';
					tmp.appendTo('body');

					delete options.require;
					self.constructor(_.extend({}, options, {
						viewModel: new viewModel.viewModel(params),
						template: templateId,
						disposeTemplate: templateId,
						isFullscreen: true
					}))
						.always(function (data) {
							if (this.state() === 'rejected') {
								promise.reject();
							} else {
								promise.resolve(data);
							}
						});
				});
				return promise;
			}

			return self.create.modal(template, viewModel)
				.pipe($)
				.pipe(function ($ui) {
					self.$ui = $ui;
					self.viewModel.addHelper.call(self, viewModel, defferedModalResult, context);
					self.events.onOpen.call(self, defferedModalResult, context, viewModel);
					self.viewModel.addLoader.call(self, viewModel);
					self.show(viewModel);
					self.events.onPromiseComplete.call(self, defferedModalResult, viewModel);
					self.events.onClose.call(self, true, defferedModalResult, viewModel);
					self.viewModel.addFullscreen.call(self, viewModel);
					self.$ui.addClass('modal-content');

					return defferedModalResult;
				});
		}
	}

	ModalHelper.prototype.show = function () {
		this.$ui.appendTo(this.$modal);

		var $dialog = this.$modal.modal(this.settings);
		var $parent = $dialog.parent();

		$parent.attr('data-bind', 'stopBinding: {}');

		if (this.settings.width) {
			$dialog.css('max-width', this.settings.width).css('width', '100%');
		}

		if (this.settings.height) {
			if (this.settings.height === 'auto') {
				$dialog.css({
					height: '100%',
					'min-height': $dialog.outerHeight()
				});
			} else {
				$dialog.css('min-height', this.settings.height);
			}
		}

		return $dialog;
	};

	ModalHelper.prototype.create = {

		hiddenDiv: function () {
			return $('<div style="display: none;"></div>').appendTo($('body'));
		},

		modal: function (templateName, viewModel) {
			var defferedElement = $.Deferred();
			var temporaryDiv = this.hiddenDiv();

			ko.renderTemplate(
				templateName,
				viewModel,
				{
					afterRender: function (nodes) {
						var $elements = $(nodes).filter(function (i, node) {
							return node.nodeType === 1;
						});
						defferedElement.resolve($elements[0]);
					}
				},
				temporaryDiv,
				'replaceNode'
			);

			return defferedElement;
		}

	};

	ModalHelper.prototype.viewModel = {

		addHelper: function (viewModel, defferedModalResult, context) {
			var self = this;
			context = context || defferedModalResult;

			viewModel.modal = {
				close: function () {
					var orgArg = arguments;

					var close = function () {
						self.closedByViewModel = true;
						if (arguments.length === 0) {
							defferedModalResult.rejectWith(context, []);
						} else {
							defferedModalResult.resolveWith(context, arguments);
						}
					};

					if (!self.dirty.check.call(self, false) && orgArg.length === 0) {
						self.dirty.showConfirmation.call(self, function () {
							if (arguments.length > 0) {
								self.doNotPreventClosing = true;
								close.apply(self, orgArg);
							}
						});
					} else {
						self.doNotPreventClosing = true;
						close.apply(self, orgArg);
					}
				},
				reloadLoader: function () {
					self.viewModel.addLoader.call(self, viewModel);
				},
				ui: this.$ui.context
			};
		},

		addFullscreen: function (viewModel) {
			var self = this;
			var $container = $(self.$modal).parent();

			if (self.settings.fullscreen) {
				viewModel.modal.fullscreen = ko.observable(false);

				// Disabled in PBI 16958
				// $(window).on("fscreenchange." + self.modalId, function (elm, isFullscreen) {
				//	viewModel.modal.fullscreen(isFullscreen);
				// });

				viewModel.modal.fullscreenSubscription = viewModel.modal.fullscreen.subscribe(function (isFullScreen) {
					if (isFullScreen) {
						self.$modal.addClass('fullscreen');
						$container.addClass('fullscreen-container');

						// Disabled in PBI 16958
						// if (!$.fullscreen.isFullScreen()) {
						//	self.viewModel.checkFullscreen.call(self);
						// }
					} else {
						self.$modal.removeClass('fullscreen');
						$container.removeClass('fullscreen-container');

						viewModel.modal.close();
						$('body, html').attr('style', null);
					}
				});

				self.viewModel.checkFullscreen.call(self, viewModel);
				// Disabled in PBI 16958
				// viewModel.modal.fullscreen($.fullscreen.isFullScreen());
			}
		},

		checkFullscreen: function (viewModel) {
			var self = this;

			viewModel.modal.fullscreen(self.settings.openFullscreen);

			// Disabled in PBI 16958
			// if (self.settings.openFullscreen) {
			//	if (!self.settings.showFullscreen) {
			//		self.$modal.fullscreen();
			//	} else {
			//		$(self.settings.showFullscreen).fullscreen();
			//	}
			// }
		},

		addLoader: function (viewModel) {
			if (viewModel.loader && viewModel.loader.state) {
				if (viewModel.loader.state() === 'pending') {
					mask.showLoader(this.$modal);
					var hidden = this.$modal.find('.modal-content').hide();
					this.$modal.addClass('loading');

					viewModel.loader.always(function () {
						mask.hideLoader(this.$modal);
						hidden.show();
						this.$modal.removeClass('loading');
					}.bind(this));
				}
			}
		}

	};

	ModalHelper.prototype.events = {

		onOpen: function (defferedModalResult, context) {
			var self = this;

			this.$modal.on($.modal.OPEN, function (event, modal) {
				var header = $('<h2></h2>');

				if (self.settings.badge) {
					header.addClass('badge');
					header.attr('data-badge', self.settings.badge);
				}

				if (self.$ui.closest('[title]').length > 0 || self.settings.title) {
					var title = (self.$ui.closest('[title]').length > 0) ? self.$ui.closest('[title]').attr('title') : self.settings.title;
					header.html('<span>{0}</span>'.formatEncodeArguments(title));
					self.$modal.addClass('withTitle');
				}

				if (self.settings.icon) {
					self.settings.iconHtml = self.settings.iconHtml.replace('{ICON}', self.settings.icon);

					$(self.settings.iconHtml).prependTo(header);
					self.$modal.addClass('withTitle');
				}

				if (!self.settings.clickClose) {
					modal.$blocker.addClass('showNoPointer');
				}

				if (self.settings.backgroundClass) {
					modal.$blocker.addClass(self.settings.backgroundClass);
				}

				if (self.settings.content) {
					self.$ui.html(self.settings.content);
				}

				if (self.settings.buttons.length) {
					var $buttonGroup = $('<div/>').addClass('button-bar');

					$.each(self.settings.buttons, function (ind, elm) {
						$('<button/>').addClass((ind === 1) ? 'btn btn-secondary' : 'btn btn-primary')
							.text(elm)
							.prependTo($buttonGroup)
							.on('click', function (e) {
								self.closedByViewModel = true;

								if ($(e.target).hasClass('btn-primary')) {
									defferedModalResult.resolveWith(context, arguments);
								} else {
									defferedModalResult.rejectWith(context, []);
								}
							});
					});

					$buttonGroup.appendTo(self.$modal);
				}

				if (header.html()) {
					header.prependTo(self.$modal);
				}

				if (self.$modal.find('.close-modal').length > 0) {
					self.$modal.addClass('withClose');
				}

				var dirtyElements = [];
				_.each(self.settings.viewModel, function (elm) {
					if (ko.isObservable(elm) && _.isFunction(elm.isDirty)) {
						elm.dirtySubscription = elm.isDirty.subscribe(function (isDirty) {
							var index = dirtyElements.indexOf(elm);

							if (isDirty) {
								if (index === -1) {
									$(window).off('beforeunload.' + self.modalId).on('beforeunload.' + self.modalId, function () {
										return Strings.ConfirmationBeforeSave;
									});

									dirtyElements.push(elm);
								}
							} else {
								if (index > -1) {
									dirtyElements.splice(index, 1);
								}

								if (dirtyElements.length === 0) {
									$(window).off('beforeunload.' + self.modalId);
								}
							}
						});
					}
				});

				$(document.activeElement).blur();
			});
		},

		onPromiseComplete: function (defferedModalResult, viewModel) {
			var self = this;

			defferedModalResult.always(function () {
				if (_.isFunction(viewModel.dispose)) {
					viewModel.dispose();
				}

				if (self.settings.disposeTemplate) {
					$('#' + self.settings.disposeTemplate).remove();
				}

				if (self.settings.fullscreen) {
					$.fullscreen.exit();
				}

				if (self.closedByViewModel) {
					$.modal.close();
					self.closedByViewModel = false;
				}

				ko.removeNode(self.$modal[0]);
				$(window)
					.trigger('resize')
					.off('beforeunload.' + self.modalId);
			});
		},

		onClose: function (doRemoveUI, defferedModalResult, viewModel) {
			var self = this;

			self.$modal.one('remove', function () {
				ko.removeNode(self.$modal[0]);
			});

			self.$modal.on($.modal.PREVENT_CLOSING, $.proxy(self.dirty.check, self, true));

			self.$modal.on($.modal.CLOSE, function () {
				self.$modal.off($.modal.PREVENT_CLOSING);

				if (doRemoveUI) {
					self.$modal.children().each(function (index, element) { ko.cleanNode(element); });
				}

				if (viewModel.modal && viewModel.modal.fullscreenSubscription) {
					// $(window).off("fscreenchange." + self.modalId);
					viewModel.modal.fullscreenSubscription.dispose();
				}

				if (viewModel) {
					_.each(viewModel, function (elm) {
						if (elm && elm.dirtySubscription) {
							elm.dirtySubscription.dispose();
						}
					});
				}
			});

			self.$modal.on($.modal.AFTER_CLOSE, function () {
				if (defferedModalResult) {
					defferedModalResult.reject();
				}
			});
		}
	};

	ModalHelper.prototype.dirty = {

		showConfirmation: function (callback) {
			new ModalHelper({
				modalClass: 'modal dialog',
				template: $('<div/>').addClass('modal-content'),
				content: Strings.ConfirmationBeforeSave,
				title: Strings.ConfirmSaveTitle,
				icon: 'Alert',
				buttons: [Strings.YesButton, Strings.CancelButton]
			}).always(callback);
		},

		check: function (showMessage) {
			var self = this;

			if (self.settings && self.settings.viewModel && !self.doNotPreventClosing) {
				var isModified = _.some(self.settings.viewModel, function (elm) {
					if (ko.isObservable(elm) && _.isFunction(elm.isDirty)) {
						return elm.isDirty();
					}
				});

				if (isModified) {
					if (showMessage) {
						self.dirty.showConfirmation(function () {
							if (arguments.length > 0) {
								self.doNotPreventClosing = true;

								setTimeout(function () {
									self.settings.viewModel.modal.close();
								}, 10);
							}
						});
					}
				}

				return !isModified;
			} else {
				return true;
			}
		}

	};

	return function (options) {
		return new ModalHelper(options);
	};
});

